import {DEFAULT_CARD_TYPES as $8fc858ffa1007a27$re_export$DEFAULT_CARD_TYPES, AMERICAN_EXPRESS as $8fc858ffa1007a27$re_export$AMERICAN_EXPRESS, DINERS_CLUB as $8fc858ffa1007a27$re_export$DINERS_CLUB, DISCOVER as $8fc858ffa1007a27$re_export$DISCOVER, ELO as $8fc858ffa1007a27$re_export$ELO, HIPER as $8fc858ffa1007a27$re_export$HIPER, HIPERCARD as $8fc858ffa1007a27$re_export$HIPERCARD, JCB as $8fc858ffa1007a27$re_export$JCB, MAESTRO as $8fc858ffa1007a27$re_export$MAESTRO, MASTERCARD as $8fc858ffa1007a27$re_export$MASTERCARD, MIR as $8fc858ffa1007a27$re_export$MIR, UNION_PAY as $8fc858ffa1007a27$re_export$UNION_PAY, VISA as $8fc858ffa1007a27$re_export$VISA, basistheory as $gb0K4$basistheory} from "@basis-theory/web-elements";
import $gb0K4$react, {useState as $gb0K4$useState, useRef as $gb0K4$useRef, useEffect as $gb0K4$useEffect, createContext as $gb0K4$createContext, useMemo as $gb0K4$useMemo, useContext as $gb0K4$useContext} from "react";
import {jsx as $gb0K4$jsx} from "react/jsx-runtime";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $6152f9bf0d6dda4d$exports = {};

$parcel$export($6152f9bf0d6dda4d$exports, "useBasisTheory", () => $af3ff746464f54fa$export$8855c0c49ada8fa3);
$parcel$export($6152f9bf0d6dda4d$exports, "BasisTheoryProvider", () => $45f18da36523d589$export$e61fbf0ee83adc05);



const $45f18da36523d589$var$BasisTheoryContext = /*#__PURE__*/ (0, $gb0K4$createContext)({});
const $45f18da36523d589$export$e61fbf0ee83adc05 = ({ bt: bt, children: children })=>{
    const value = (0, $gb0K4$useMemo)(()=>({
            bt: bt
        }), [
        bt
    ]);
    return /*#__PURE__*/ (0, $gb0K4$jsx)($45f18da36523d589$var$BasisTheoryContext.Provider, {
        value: value,
        children: children
    });
};
const $45f18da36523d589$export$e3c9ec56296efb13 = ()=>(0, $gb0K4$useContext)($45f18da36523d589$var$BasisTheoryContext);



const $af3ff746464f54fa$export$8855c0c49ada8fa3 = (apiKey, options)=>{
    const [state, setState] = (0, $gb0K4$useState)({});
    const isLoading = (0, $gb0K4$useRef)(false);
    const { bt: btFromContext } = (0, $45f18da36523d589$export$e3c9ec56296efb13)();
    (0, $gb0K4$useEffect)(()=>{
        (async ()=>{
            if (!state.bt && apiKey && !state.error && !isLoading.current) try {
                isLoading.current = true;
                const bt = await (0, $gb0K4$basistheory)(apiKey, options);
                setState({
                    bt: bt
                });
            } catch (error) {
                setState({
                    error: error
                });
            } finally{
                isLoading.current = false;
            }
        })();
    }, [
        state.bt,
        apiKey,
        options,
        state.error
    ]);
    if (state.bt || state.error) return {
        bt: state.bt,
        error: state.error
    };
    return {
        bt: btFromContext
    };
};





var $6b778c3bc65591b7$exports = {};

$parcel$export($6b778c3bc65591b7$exports, "CardElement", () => $22a85849b67e3ab0$export$642653cabb64aed9);
$parcel$export($6b778c3bc65591b7$exports, "CardExpirationDateElement", () => $b04bbbda03b8923f$export$d5128efc3cebc889);
$parcel$export($6b778c3bc65591b7$exports, "CardNumberElement", () => $c9d0638264a6246e$export$a2311b18160d2f3f);
$parcel$export($6b778c3bc65591b7$exports, "CardVerificationCodeElement", () => $6f922196262b492d$export$36d668a024913c87);
$parcel$export($6b778c3bc65591b7$exports, "CopyButtonElement", () => $b1b4bfddfa231c63$export$6b67f0b47b983f4f);
$parcel$export($6b778c3bc65591b7$exports, "TextElement", () => $098244fc1ecf3b22$export$764077542c4bf9bd);




/**
 * Resolves which BasisTheoryReact instance to use,
 * by favoring the optional parameter.
 * For internal use only.
 * @param bt
 * @returns parameter if it exists; instance from Context otherwise
 */ const $d817aaffef1200c1$export$ca8f72eaa6c308fa = (bt)=>{
    const { bt: btFromContext } = (0, $af3ff746464f54fa$export$8855c0c49ada8fa3)();
    return bt || btFromContext;
};


const $001f9ef7a572da43$var$elementHasSetValueRef = (val)=>Boolean(val.setValueRef);
const $001f9ef7a572da43$var$shallowDifference = (objA, objB)=>[
        ...new Set([
            ...Object.keys(objA || {}),
            ...Object.keys(objB || {})
        ])
    ].reduce((changed, key)=>{
        const aValue = objA?.[key];
        const bValue = objB?.[key];
        if (aValue !== bValue) return {
            ...changed,
            [key]: bValue
        };
        return changed;
    }, {});
/**
 * Creates, mounts and indexes an Element
 * with React lifecycle
 * @param id
 * @param type
 * @param options
 * @param wrapperRef
 * @param btFromProps
 * @param ref optional ref to set the underlying element
 * @returns created element and initial options used for mounting
 */ const $001f9ef7a572da43$export$93e1bc7222cfbdc8 = (id, type, wrapperRef, options, btFromProps, ref, targetValueRef)=>{
    const bt = (0, $d817aaffef1200c1$export$ca8f72eaa6c308fa)(btFromProps);
    const [lastOptions, setLastOptions] = (0, $gb0K4$useState)();
    const elementRef = (0, $gb0K4$useRef)(null);
    (0, $gb0K4$useEffect)(()=>{
        if (bt && wrapperRef.current && !elementRef.current) {
            const newElement = bt.createElement(type, options); // conversion to unknown necessary because of different value prop types
            elementRef.current = newElement;
            if (typeof ref === 'function') ref(newElement);
            if (ref && typeof ref === 'object') // eslint-disable-next-line no-param-reassign
            ref.current = newElement;
            (async ()=>{
                await newElement.mount(`#${id}`).catch((mountError)=>{
                    setLastOptions(()=>{
                        throw mountError;
                    });
                });
                if ($001f9ef7a572da43$var$elementHasSetValueRef(newElement) && targetValueRef?.current) newElement.setValueRef(targetValueRef.current);
            })();
            setLastOptions(options);
        }
    // the only two dependencies that we need to watch for
    // are bt and wrapperRef. Anything else changing should not
    // be considered for creating/mounting an element
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        bt,
        wrapperRef
    ]);
    (0, $gb0K4$useEffect)(()=>{
        if (elementRef.current && lastOptions && options !== lastOptions) {
            const optionsDifference = $001f9ef7a572da43$var$shallowDifference(lastOptions, options);
            if (Object.keys(optionsDifference).length) {
                setLastOptions(options);
                elementRef.current.update(optionsDifference).catch((updateError)=>{
                    setLastOptions(()=>{
                        throw updateError;
                    });
                });
            }
        }
    }, [
        options,
        lastOptions
    ]);
    return elementRef?.current || undefined;
};



const $1b6d06f13820d117$export$b6487193f4d880e0 = (eventType, element, listener)=>(0, $gb0K4$useEffect)(()=>{
        let subscription;
        if (element && listener) subscription = element.on(eventType, listener);
        return ()=>subscription?.unsubscribe();
    // we shouldn't run this effect when eventType changes
    // which would turn out to be a different listener
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        element,
        listener
    ]);


const $22a85849b67e3ab0$var$CardElementC = ({ autoComplete: autoComplete, binLookup: binLookup, bt: bt, cardTypes: cardTypes, coBadgedSupport: coBadgedSupport, copyIconStyles: copyIconStyles, disabled: disabled, elementRef: elementRef, enableCopy: enableCopy, id: id, inputMode: inputMode, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onKeyDown: onKeyDown, onReady: onReady, placeholder: placeholder, readOnly: readOnly, skipLuhnValidation: skipLuhnValidation, style: style, title: title, validateOnChange: validateOnChange, value: value })=>{
    const wrapperRef = (0, $gb0K4$useRef)(null);
    const element = (0, $001f9ef7a572da43$export$93e1bc7222cfbdc8)(id, 'card', wrapperRef, {
        autoComplete: autoComplete,
        cardTypes: cardTypes,
        copyIconStyles: copyIconStyles,
        disabled: disabled,
        enableCopy: enableCopy,
        binLookup: binLookup,
        coBadgedSupport: coBadgedSupport,
        inputMode: inputMode,
        placeholder: placeholder,
        readOnly: readOnly,
        skipLuhnValidation: skipLuhnValidation,
        style: style,
        title: title,
        validateOnChange: validateOnChange,
        value: value
    }, bt, elementRef);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('ready', element, onReady);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('change', element, onChange);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('focus', element, onFocus);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('blur', element, onBlur);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('keydown', element, onKeyDown);
    return /*#__PURE__*/ (0, $gb0K4$jsx)("div", {
        id: id,
        ref: wrapperRef
    });
};
const $22a85849b67e3ab0$export$642653cabb64aed9 = /*#__PURE__*/ (0, $gb0K4$react).forwardRef(// eslint-disable-next-line get-off-my-lawn/prefer-arrow-functions
function CardElement(props, ref) {
    return /*#__PURE__*/ (0, $gb0K4$jsx)($22a85849b67e3ab0$var$CardElementC, {
        ...props,
        elementRef: ref
    });
});






const $b04bbbda03b8923f$var$CardExpirationDateElementC = ({ 'aria-label': ariaLabel, autoComplete: autoComplete, bt: bt, copyIconStyles: copyIconStyles, disabled: disabled, elementRef: elementRef, enableCopy: enableCopy, id: id, inputMode: inputMode, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onKeyDown: onKeyDown, onReady: onReady, placeholder: placeholder, readOnly: readOnly, style: style, title: title, validateOnChange: validateOnChange, value: value, valueRef: valueRef })=>{
    const wrapperRef = (0, $gb0K4$useRef)(null);
    const element = (0, $001f9ef7a572da43$export$93e1bc7222cfbdc8)(id, 'cardExpirationDate', wrapperRef, {
        'aria-label': ariaLabel,
        autoComplete: autoComplete,
        copyIconStyles: copyIconStyles,
        disabled: disabled,
        enableCopy: enableCopy,
        inputMode: inputMode,
        placeholder: placeholder,
        readOnly: readOnly,
        style: style,
        targetId: id,
        title: title,
        validateOnChange: validateOnChange,
        value: value
    }, bt, elementRef, valueRef);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('ready', element, onReady);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('change', element, onChange);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('focus', element, onFocus);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('blur', element, onBlur);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('keydown', element, onKeyDown);
    return /*#__PURE__*/ (0, $gb0K4$jsx)("div", {
        id: id,
        ref: wrapperRef
    });
};
const $b04bbbda03b8923f$export$d5128efc3cebc889 = /*#__PURE__*/ (0, $gb0K4$react).forwardRef(function CardExpirationDateElement(props, ref) {
    return /*#__PURE__*/ (0, $gb0K4$jsx)($b04bbbda03b8923f$var$CardExpirationDateElementC, {
        ...props,
        elementRef: ref
    });
});






const $c9d0638264a6246e$var$CardNumberElementC = ({ 'aria-label': ariaLabel, autoComplete: autoComplete, binLookup: binLookup, bt: bt, cardTypes: cardTypes, copyIconStyles: copyIconStyles, coBadgedSupport: coBadgedSupport, disabled: disabled, elementRef: elementRef, enableCopy: enableCopy, iconPosition: iconPosition, id: id, inputMode: inputMode, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onKeyDown: onKeyDown, onReady: onReady, placeholder: placeholder, readOnly: readOnly, skipLuhnValidation: skipLuhnValidation, style: style, title: title, validateOnChange: validateOnChange, value: value, valueRef: valueRef })=>{
    const wrapperRef = (0, $gb0K4$useRef)(null);
    const element = (0, $001f9ef7a572da43$export$93e1bc7222cfbdc8)(id, 'cardNumber', wrapperRef, {
        'aria-label': ariaLabel,
        autoComplete: autoComplete,
        binLookup: binLookup,
        cardTypes: cardTypes,
        copyIconStyles: copyIconStyles,
        coBadgedSupport: coBadgedSupport,
        disabled: disabled,
        enableCopy: enableCopy,
        iconPosition: iconPosition,
        inputMode: inputMode,
        placeholder: placeholder,
        readOnly: readOnly,
        skipLuhnValidation: skipLuhnValidation,
        style: style,
        targetId: id,
        title: title,
        validateOnChange: validateOnChange,
        value: value
    }, bt, elementRef, valueRef);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('ready', element, onReady);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('change', element, onChange);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('focus', element, onFocus);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('blur', element, onBlur);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('keydown', element, onKeyDown);
    return /*#__PURE__*/ (0, $gb0K4$jsx)("div", {
        id: id,
        ref: wrapperRef
    });
};
const $c9d0638264a6246e$export$a2311b18160d2f3f = /*#__PURE__*/ (0, $gb0K4$react).forwardRef(function CardNumberElement(props, ref) {
    return /*#__PURE__*/ (0, $gb0K4$jsx)($c9d0638264a6246e$var$CardNumberElementC, {
        ...props,
        elementRef: ref
    });
});






const $6f922196262b492d$var$CardVerificationCodeElementC = ({ 'aria-label': ariaLabel, autoComplete: autoComplete, bt: bt, cardBrand: cardBrand, copyIconStyles: copyIconStyles, disabled: disabled, elementRef: elementRef, enableCopy: enableCopy, id: id, inputMode: inputMode, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onKeyDown: onKeyDown, onReady: onReady, placeholder: placeholder, readOnly: readOnly, style: style, title: title, validateOnChange: validateOnChange, value: value, valueRef: valueRef })=>{
    const wrapperRef = (0, $gb0K4$useRef)(null);
    const element = (0, $001f9ef7a572da43$export$93e1bc7222cfbdc8)(id, 'cardVerificationCode', wrapperRef, {
        'aria-label': ariaLabel,
        autoComplete: autoComplete,
        cardBrand: cardBrand,
        copyIconStyles: copyIconStyles,
        disabled: disabled,
        enableCopy: enableCopy,
        inputMode: inputMode,
        placeholder: placeholder,
        readOnly: readOnly,
        style: style,
        targetId: id,
        title: title,
        validateOnChange: validateOnChange,
        value: value
    }, bt, elementRef, valueRef);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('ready', element, onReady);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('change', element, onChange);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('focus', element, onFocus);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('blur', element, onBlur);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('keydown', element, onKeyDown);
    return /*#__PURE__*/ (0, $gb0K4$jsx)("div", {
        id: id,
        ref: wrapperRef
    });
};
const $6f922196262b492d$export$36d668a024913c87 = /*#__PURE__*/ (0, $gb0K4$react).forwardRef(function CardVerificationCodeElement(props, ref) {
    return /*#__PURE__*/ (0, $gb0K4$jsx)($6f922196262b492d$var$CardVerificationCodeElementC, {
        ...props,
        elementRef: ref
    });
});






const $b1b4bfddfa231c63$var$CopyButtonElementC = ({ bt: bt, elementRef: elementRef, id: id, text: text, onClick: onClick, style: style, valueRef: valueRef })=>{
    const wrapperRef = (0, $gb0K4$useRef)(null);
    const element = (0, $001f9ef7a572da43$export$93e1bc7222cfbdc8)(id, 'copyButton', wrapperRef, {
        targetId: id,
        style: style,
        text: text
    }, bt, elementRef, valueRef);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('click', element, onClick);
    return /*#__PURE__*/ (0, $gb0K4$jsx)("div", {
        id: id,
        ref: wrapperRef
    });
};
const $b1b4bfddfa231c63$export$6b67f0b47b983f4f = /*#__PURE__*/ (0, $gb0K4$react).forwardRef(function CardNumberElement(props, ref) {
    return /*#__PURE__*/ (0, $gb0K4$jsx)($b1b4bfddfa231c63$var$CopyButtonElementC, {
        ...props,
        elementRef: ref
    });
});






const $098244fc1ecf3b22$var$TextElementC = ({ 'aria-label': ariaLabel, autoComplete: autoComplete, bt: bt, disabled: disabled, elementRef: elementRef, id: id, inputMode: inputMode, mask: mask, maxLength: maxLength, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onKeyDown: onKeyDown, onReady: onReady, password: password, placeholder: placeholder, readOnly: readOnly, style: style, title: title, transform: transform, validateOnChange: validateOnChange, validation: validation, value: value, valueRef: valueRef })=>{
    const wrapperRef = (0, $gb0K4$useRef)(null);
    const element = (0, $001f9ef7a572da43$export$93e1bc7222cfbdc8)(id, 'text', wrapperRef, {
        'aria-label': ariaLabel,
        autoComplete: autoComplete,
        disabled: disabled,
        inputMode: inputMode,
        mask: mask,
        maxLength: maxLength,
        password: password,
        placeholder: placeholder,
        readOnly: readOnly,
        style: style,
        targetId: id,
        title: title,
        transform: transform,
        validateOnChange: validateOnChange,
        validation: validation,
        value: value
    }, bt, elementRef, valueRef);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('ready', element, onReady);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('change', element, onChange);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('focus', element, onFocus);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('blur', element, onBlur);
    (0, $1b6d06f13820d117$export$b6487193f4d880e0)('keydown', element, onKeyDown);
    return /*#__PURE__*/ (0, $gb0K4$jsx)("div", {
        id: id,
        ref: wrapperRef
    });
};
const $098244fc1ecf3b22$export$764077542c4bf9bd = /*#__PURE__*/ (0, $gb0K4$react).forwardRef(// eslint-disable-next-line get-off-my-lawn/prefer-arrow-functions
function TextElement(props, ref) {
    return /*#__PURE__*/ (0, $gb0K4$jsx)($098244fc1ecf3b22$var$TextElementC, {
        ...props,
        elementRef: ref
    });
});




var $17e03523eeef3efb$exports = {};




export {$8fc858ffa1007a27$re_export$DEFAULT_CARD_TYPES as DEFAULT_CARD_TYPES, $8fc858ffa1007a27$re_export$AMERICAN_EXPRESS as AMERICAN_EXPRESS, $8fc858ffa1007a27$re_export$DINERS_CLUB as DINERS_CLUB, $8fc858ffa1007a27$re_export$DISCOVER as DISCOVER, $8fc858ffa1007a27$re_export$ELO as ELO, $8fc858ffa1007a27$re_export$HIPER as HIPER, $8fc858ffa1007a27$re_export$HIPERCARD as HIPERCARD, $8fc858ffa1007a27$re_export$JCB as JCB, $8fc858ffa1007a27$re_export$MAESTRO as MAESTRO, $8fc858ffa1007a27$re_export$MASTERCARD as MASTERCARD, $8fc858ffa1007a27$re_export$MIR as MIR, $8fc858ffa1007a27$re_export$UNION_PAY as UNION_PAY, $8fc858ffa1007a27$re_export$VISA as VISA, $af3ff746464f54fa$export$8855c0c49ada8fa3 as useBasisTheory, $45f18da36523d589$export$e61fbf0ee83adc05 as BasisTheoryProvider, $22a85849b67e3ab0$export$642653cabb64aed9 as CardElement, $b04bbbda03b8923f$export$d5128efc3cebc889 as CardExpirationDateElement, $c9d0638264a6246e$export$a2311b18160d2f3f as CardNumberElement, $6f922196262b492d$export$36d668a024913c87 as CardVerificationCodeElement, $b1b4bfddfa231c63$export$6b67f0b47b983f4f as CopyButtonElement, $098244fc1ecf3b22$export$764077542c4bf9bd as TextElement};
